export const filterOptionsForTotal = (options: ReadonlyArray<number>, total: number) => {
  if (options[0] >= total) return undefined
  let stop = false
  const filteredOptions: Array<number> = []
  options.every((option) => {
    if (stop) return false
    const real = Math.min(option, total)
    filteredOptions.push(real)
    stop = real !== option
    return true
  })
  return filteredOptions
}
